var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconDocumentSign = function SvgIconDocumentSign(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    fill: "none",
    viewBox: "0 0 32 32"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M16 28H8V4h8v6a2.006 2.006 0 0 0 2 2h6v4h2v-6a.91.91 0 0 0-.3-.7l-7-7A.9.9 0 0 0 18 2H8a2.006 2.006 0 0 0-2 2v24a2.006 2.006 0 0 0 2 2h8zm2-23.6 5.6 5.6H18z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#30B7FD",
    d: "m29.84 21.025-2.47-2.537a.81.81 0 0 0-.581-.248.81.81 0 0 0-.582.248l-7.647 7.859v3.733h3.632l7.647-7.86a.858.858 0 0 0 0-1.196m-8.33 7.364h-1.304v-1.342l4.114-4.228 1.305 1.34zm5.279-5.425-1.305-1.341 1.305-1.342 1.305 1.342z"
  })));
};
export default SvgIconDocumentSign;